import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-save-sub-admin',
  templateUrl: './save-sub-admin.component.html',
  styleUrls: ['./save-sub-admin.component.css']
})
export class SaveSubAdminComponent implements OnInit {
  headingText = 'Add New Admin';
  subAdminForm: FormGroup;
  formSubmitted = false;
  permissions: any[];
  isUpdate = false;
  adminDetails: any;
  showPassword = false;
  loaderText = 'Loading details...';

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private auth: AuthService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.subAdminForm = this.fb.group({
      user_email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      name: ['', Validators.required],
      dashboard: [true],
      userData: [false],
      resources: [false],
      notification: [false],
      contactUs: [false],
      homeContent: [false],
      blogs: [false],
      isSuperAdmin: [false],
    });

    this.permissions = [
      { key: 'userData', name: 'Customers', isChecked: false },
      { key: 'resources', name: 'Resources', isChecked: false },
      { key: 'locations', name: 'Locations', isChecked: false },
      {
        key: 'notification',
        name: 'Notifications',
        isChecked: false,
      },
      { key: 'isSuperAdmin', name: 'Sub admins', isChecked: false },
      { key: 'contactUs', name: 'Contact us', isChecked: false },
      { key: 'homeContent', name: 'Home content', isChecked: false },
      { key: 'blogs', name: 'Blogs', isChecked: false },
    ];
  }

  ngOnInit(): void {
    if (this.route.snapshot.params.id) {
      this.isUpdate = true;
      this.getAdminProfile(this.route.snapshot.params.id);
      this.subAdminForm.controls['user_email'].disable();
      this.headingText = 'Update Sub Admin';
    } else {
      this.isUpdate = false;
      this.subAdminForm.controls['user_email'].enable();
    }
  }

  getAdminProfile(adminId) {
    this.spinner.show();
    this.auth.getAllSubAdmins().subscribe(
      (res: any) => {
        if (res.status) {
          this.spinner.hide();
          this.adminDetails = res.adminData.find((admin) => admin._id == adminId);
          this.subAdminForm.patchValue(this.adminDetails);
          this.permissions.map((p) => {
            p.isChecked = this.adminDetails[p.key];
          });
        }
      },
      (errors: any) => {
        this.spinner.hide();
      }
    );
  }

  onSubmit() {
    this.loaderText = 'Saving details...';
    this.spinner.show();
    const permissions = this.permissions.reduce(
      (obj, item) => ({ ...obj, [item.key]: item.isChecked }),
      {}
    );

    const admin = { ...this.adminDetails, ...this.subAdminForm.value };

    const payload = {
      ...admin,
      ...permissions,
    };

    payload.id = payload._id;
    payload.dashboard = true;

    if (!this.isUpdate) {
      this.auth.createSubAdmin(payload).subscribe(
        (res: any) => {
          if (res.status) {
            this.spinner.hide();
            this.toastr.success(res.message, 'Successs', {
              timeOut: 2500,
              progressBar: true,
              progressAnimation: 'increasing',
              positionClass: 'toast-top-right',
            });
            this.router.navigateByUrl('/admin/sub-admin');
          }
        },
        (errors: any) => {
          this.spinner.hide();
          this.toastr.error(errors.error.description, 'Error Occured', {
            timeOut: 2500,
            progressBar: true,
            progressAnimation: 'increasing',
            positionClass: 'toast-top-right',
          });
        }
      );
    } else {
      if (this.adminDetails.password === this.subAdminForm.value.password) {
        delete payload.password;
      }

      this.auth.editSubAdmin(payload).subscribe(
        (res: any) => {
          if (res.status) {
            this.spinner.hide();
            this.toastr.success(res.message, 'Successs', {
              timeOut: 2500,
              progressBar: true,
              progressAnimation: 'increasing',
              positionClass: 'toast-top-right',
            });
            this.router.navigateByUrl('/admin/sub-admins');
          }
        },
        (errors: any) => {
          this.spinner.hide();
          this.toastr.error(errors.error.description, 'Error Occured', {
            timeOut: 2500,
            progressBar: true,
            progressAnimation: 'increasing',
            positionClass: 'toast-top-right',
          });
        }
      );
    }
  }

  passwordVisibility() {
    this.showPassword = !this.showPassword;
  } 

}
